module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-hp",
    class: {
      'cb-hp--hidden': !_vm.isAndroidInstagram()
    },
    attrs: {
      "id": "app",
      "tabindex": "0",
      "lang": "en",
      "role": "dialog",
      "aria-labelledby": "dialog1Title",
      "aria-describedby": "dialog1Desc"
    }
  }, [_c('h2', {
    staticClass: "no-display",
    attrs: {
      "id": "dialog1Title"
    }
  }, [_vm._v("Billing Modal")]), _vm._v(" "), _c('p', {
    staticClass: "no-display",
    attrs: {
      "id": "dialog1Desc"
    }
  }, [_vm._v("Billing modal powered by Chargebee")]), _vm._v(" "), (_vm.inited) ? _c('router-view') : _vm._e(), _vm._v(" "), (!_vm.hideClose) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-hp__close",
    class: {
      'cb-hp__close--inside': _vm.isMobileIframe, 'cb-hp__close--show': _vm.isMobileIframe && _vm.show_iframe_close
    },
    attrs: {
      "role": "button",
      "aria-label": "close checkout",
      "data-cb-id": "cb_close"
    },
    on: {
      "click": _vm.close,
      "keydown": _vm.closeKey
    }
  }, [_c('i', {
    staticClass: "icon-remove cb-hp__close-icon"
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1083cf9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 294
// module chunks = 83 84